// log.js

const devMode = false;

export function log(s) {
  if( devMode ) {
    console.log(s);
  }
}
